import { Menu } from "antd";
import "./style.css";
import { Link, useLocation } from "react-router-dom";

const TEXT = {
  dashboard: 'Dashboard Hội Viên',
  manager_account: 'Quản lý tài khoản',
  history: 'Lịch sử',
  gamingHis: 'Lịch sử dự đoán',
  conversionHis: 'Lịch sử quy đổi DTC',
  playHis: 'Lịch sử user tham gia',
  mannager_game: 'Quản lý game',
  setup_countdown: 'Cài đặt hiển thị',
  setup_condition: 'Cài đặt điều kiện',
  setup_score: 'Cài đặt tỉ lệ trả thưởng',
  setup_rule: 'Cài đặt thể lệ',
  update_turn: 'Thêm/bớt lượt chơi',
  popup_fake_user: 'Quản lý popup trúng thưởng lớn',
  confirm_result: 'Xác nhận kết quả',
  leaderboard: 'Bảng xếp hạng',
  leaderboard_settings: 'Cài đặt BXH',
}

const SideBarCustom = () => {
  const auth = JSON.parse(localStorage.getItem("auth"));

  let location = useLocation();
  const currentPath = location.pathname;

  const menuItemsSuperAdmin = [
    {
      key: '/dashboard',
      label: <Link to="/dashboard">{TEXT.dashboard}</Link>,
    },
    {
      key: '/account',
      label: <Link to="/account">{TEXT.manager_account}</Link>,
    },
    {
      label: TEXT.history,
      key: 'history',
      style: { padding: "0" },
      children: [
        {
          label: <Link to="/conversionHis">{TEXT.conversionHis}</Link>,
          key: "/conversionHis",
        },
        {
          label: <Link to="/playHis">{TEXT.playHis}</Link>,
          key: "/playHis",
        },
        {
          label: <Link to="/gamingHis">{TEXT.gamingHis}</Link>,
          key: "/gamingHis",
        }
      ],
    },
    {
      label: TEXT.mannager_game,
      key: 'mannager_game',
      style: { padding: "0" },
      children: [
        {
          label: <Link to="/setup_countdown">{TEXT.setup_countdown}</Link>,
          key: "/setup_countdown",
        },
        {
          label: <Link to="/setup_condition">{TEXT.setup_condition}</Link>,
          key: "/setup_condition",
        },
        {
          label: <Link to="/setup_score">{TEXT.setup_score}</Link>,
          key: "/setup_score",
        },
        {
          label: <Link to="/setup_rule">{TEXT.setup_rule}</Link>,
          key: "/setup_rule",
        },
        {
          label: <Link to="/update_turn">{TEXT.update_turn}</Link>,
          key: "/update_turn",
        },
        {
          label: <Link to="/popup_fake_user">{TEXT.popup_fake_user}</Link>,
          key: "/popup_fake_user",
        },
      ],
    },
    {
      key: "/confirm_result",
      label: <Link to="/confirm_result">{TEXT.confirm_result}</Link>,
    },
    {
      key: "/leaderboard",
      label: <Link to="/leaderboard">{TEXT.leaderboard}</Link>,
    },
    {
      key: "/leaderboard_settings",
      label: <Link to="/leaderboard_settings">{TEXT.leaderboard_settings}</Link>,
    },
  ];

  const menuItemsAdmin = [
    {
      key: '/dashboard',
      label: <Link to="/dashboard">{TEXT.dashboard}</Link>,
    },
    {
      key: '/account',
      label: <Link to="/account">{TEXT.manager_account}</Link>,
    },
    {
      label: TEXT.history,
      key: 'history',
      style: { padding: "0" },
      children: [
        {
          label: <Link to="/conversionHis">{TEXT.conversionHis}</Link>,
          key: "/conversionHis",
        },
        {
          label: <Link to="/playHis">{TEXT.playHis}</Link>,
          key: "/playHis",
        },
        {
          label: <Link to="/gamingHis">{TEXT.gamingHis}</Link>,
          key: "/gamingHis",
        }
      ],
    },
    {
      key: "/leaderboard",
      label: <Link to="/leaderboard">{TEXT.leaderboard}</Link>,
    },
  ]

  return (
    <>
      <div className="logo font-extrabold flex text-center">Hậu Đài Game DỰ ĐOÁN ASEAN CUP 2026 VIỆT NAM</div>
      <Menu 
        mode="inline"
        selectedKeys={[currentPath]}
        items={auth?.role === "super_admin" ? menuItemsSuperAdmin : menuItemsAdmin}
      />
    </>
  );
};

export default SideBarCustom;
